import type { RefObject } from 'react';
import { useCallback, useState } from 'react';

import { useWidget } from '../../../../../../contexts/widgets';
import {
  forwardCoverRepositionAttributes,
  forwardCoverRepositionAttributesWithKeys,
} from '../../../../../../services/event-handler';

export const useCover = (coverRef: RefObject<HTMLDivElement>) => {
  const { host, profilePage, handlers } = useWidget();

  const { isCoverRepositionMode } = profilePage;
  const { changeCoverPosition } = handlers;

  const [isCoverMoving, setIsCoverMoving] = useState(false);

  const handleCoverPositionChange = useCallback(
    (event: MouseEvent | React.KeyboardEvent) => {
      const coverWidth = host?.dimensions?.width ?? 0;

      if (event instanceof MouseEvent) {
        return forwardCoverRepositionAttributes(
          changeCoverPosition,
          coverWidth,
        )(event);
      }

      return forwardCoverRepositionAttributesWithKeys(
        changeCoverPosition,
        coverWidth,
      )(event);
    },
    [changeCoverPosition, host?.dimensions?.width],
  );

  const startRepositioningCover = () => {
    if (isCoverRepositionMode && coverRef.current) {
      coverRef.current.addEventListener('mousemove', handleCoverPositionChange);
      setIsCoverMoving(true);
    }
  };

  const stopRepositioningCover = () => {
    if (isCoverRepositionMode && coverRef.current) {
      coverRef.current.removeEventListener(
        'mousemove',
        handleCoverPositionChange,
      );
      setIsCoverMoving(false);
    }
  };

  return {
    isCoverMoving,
    actions: {
      handleCoverPositionChange,
      startRepositioningCover,
      stopRepositioningCover,
    },
  };
};
